import { render } from "./IDPDashboard.vue?vue&type=template&id=b251d22c&scoped=true"
import script from "./IDPDashboard.vue?vue&type=script&lang=js"
export * from "./IDPDashboard.vue?vue&type=script&lang=js"

import "./IDPDashboard.vue?vue&type=style&index=0&id=b251d22c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b251d22c"]])

export default __exports__